const scope = {
    name_exists: '범위 이름 {{name}}이/가 이미 사용 중이에요.',
    name_with_space: '범위 이름에 공백을 포함할 수 없어요.',
};
export default Object.freeze(scope);
